(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("L"));
	else if(typeof define === 'function' && define.amd)
		define(["L"], factory);
	else if(typeof exports === 'object')
		exports["semanticMap"] = factory(require("L"));
	else
		root["semanticMap"] = factory(root["L"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_leaflet__) {
return 